// Copyright 2018 Sorama B.V.

import { GenericMeasurement } from "./SoramaWebApi";

export class MeasurementFamilyNode {
    public get id(): string {
        return this.measurement.id;
    }

    public children: MeasurementFamilyNode[] = [];

    constructor(public readonly measurement: GenericMeasurement) {}

    public get all(): GenericMeasurement[] {
        const childMeasurements = this.children.map((x: MeasurementFamilyNode) => {
            return x.all;
        });
        const flattenChilds = (<GenericMeasurement[]>[]).concat(...childMeasurements);
        return [this.measurement, ...flattenChilds];
    }

    public some(pred: (measurement: GenericMeasurement) => boolean): boolean {
        return !!this.find(pred);
    }

    public find(pred: (measurement: GenericMeasurement) => boolean): GenericMeasurement {
        if (pred(this.measurement)) {
            return this.measurement;
        }

        for (const node of this.children) {
            const m = node.find(pred);
            if (m) return m;
        }

        return undefined;
    }

    public static fromSet(measurement: GenericMeasurement[]): MeasurementFamilyNode[] {
        // Start by finding all root measurements
        const rootNodes = measurement.filter((x) => !x.isComputedMeasurement).map((x) => new MeasurementFamilyNode(x));

        for (const rootNode of rootNodes) {
            rootNode.fillNode(measurement);
        }

        return rootNodes;
    }

    private fillNode(measurement: GenericMeasurement[]): void {
        const children = measurement
            .filter((x) => x.computedMeasurementSourceId === this.measurement.id)
            .map((x) => new MeasurementFamilyNode(x));

        for (const child of children) {
            child.fillNode(measurement);
        }

        this.children = children;
    }
}
